import React from 'react'
import ReactDOM from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

import { isPlaygroundMode } from './playground/mode'

async function startApp() {
    if (isPlaygroundMode()) {
        try {
            const { worker } = await import('./playground/msw/browser')
            await worker.start({ onUnhandledRequest: 'bypass' })
        } catch (err) {
            console.error('playground: MSW failed to start', err)
        }
    }

    ReactDOM.hydrateRoot(
        document,
        <React.StrictMode>
            <HydratedRouter />
        </React.StrictMode>
    )
}

void startApp()
